import * as Sentry from '@sentry/vue';
import {App} from 'vue';
import {Router} from 'vue-router';

export function useSentry(app: App, router: Router) {
    if (document.location.hostname.indexOf('maxoptra.com') === -1) {
        return;
    }
    Sentry.init({
        release: RELEASE_VERSION,
        app,
        dsn: 'https://d38ce6571536444e8da4206a0e04bcf8@sentry.maxoptra.com/3',
        integrations: [
            Sentry.browserTracingIntegration({router}),
            Sentry.replayIntegration(),
            Sentry.vueIntegration({Vue: app, tracingOptions: {trackComponents: true}})
        ],
        tracesSampleRate: 1.0
    });
}
